import { gql } from "@apollo/client";
import { TerminalTypesInfo } from "./getTerminalTypesCall";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const PANEL_CREATE_SECTION = gql`
  mutation CreateSection($domain: String!, $sectionName: String!, $panelSectionType: Int!, $systemId: Int!, $section: [CreateLocation!]!, $terminalLinks: [CreateTerminalLink!]) {
    section {
      create(domain: $domain, sectionName: $sectionName, panelSectionType: $panelSectionType, systemId: $systemId, section: $section, terminalLinks: $terminalLinks) {
        code
        success
        message
        updatedValues
      }
    }
  }
`

export interface CreatePanelLocation {
  location_name: string;
  visual: string;
  terminals: {device_id: number, terminal_type?: number | null, config?: Omit<TerminalTypesInfo, "input">, port: number}[]
}

export interface CreateTerminalLink {
  device_id: number;
  port: number;
  next_device_id?: number;
  next_port?: number;
  parent_device_id?: number;
  parent_port?: number;
}

export interface CreatePanelLocationResponse {
  section: {
    create: Response;
  }
}

interface Response extends Def_MutationResponse {
  updatedValues?: number[]
}